module.exports = __webpack_public_path__ + "static/media/solar_panel_background.51a676c2.png";